import QuestionBankPage from './QuestionBankPage'
import { questionBankMenu } from './sideBarOption'

export { questionBankMenu }
export default QuestionBankPage
